import { DataSourceCode } from "@syla/shared/types/models/DataSourceBase";

export const buildExplorerUrl = ({
  code,
  txHash,
}: {
  txHash: string;
  code?: DataSourceCode;
}) => {
  const escapedHash = encodeURIComponent(txHash);
  switch (code) {
    case DataSourceCode.Ethereum:
      return `https://etherscan.io/tx/${escapedHash}`;
    case DataSourceCode.BSC:
      return `https://bscscan.com/tx/${escapedHash}`;
    case DataSourceCode.Celo:
      return `https://celoscan.io/tx/${escapedHash}`;
    case DataSourceCode.Polygon:
      return `https://polygonscan.com/tx/${escapedHash}`;
    case DataSourceCode.FTM:
      return `https://ftmscan.com/tx/${escapedHash}`;
    case DataSourceCode.Cronos:
      return `https://cronoscan.com/tx/${escapedHash}`;
    case DataSourceCode.Moonbeam:
      return `https://moonscan.io/tx/${escapedHash}`;
    default:
      return `https://blockchair.com/search?q=${escapedHash}&from=syla`; // add `from=syla` for referral benefits
  }
};
